import { render } from "./ClientSearch.vue?vue&type=template&id=6a69d930&scoped=true&ts=true"
import script from "./ClientSearch.vue?vue&type=script&lang=ts"
export * from "./ClientSearch.vue?vue&type=script&lang=ts"

import "./ClientSearch.vue?vue&type=style&index=0&id=6a69d930&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a69d930"]])

export default __exports__